<template>
  <div
    :class="{
      'text-question--disabled': disabled,
      'text-question--error': error,
    }"
  >
    <div v-if="isEditMode">
      <v-textarea
        data-private
        dense
        outlined
        no-resize
        auto-grow
        class="flex-grow-1"
        row-height="15"
        :maxlength="maxLength"
        :error="error"
        :data-testid="tid"
        :data-tourid="tourId"
        :label="question"
        :disabled="disabled"
        :placeholder="placeholder"
        :value="value"
        :counter="maxLength"
        :rows="rows"
        @blur="$emit('focusOut')"
        @input="$emit('input', $event)"
        @focus="ensurePlaceholderVisibility"
      >
      </v-textarea>
    </div>
    <div v-else class="d-flex flex-column align-start" :data-tourid="tourId">
      <FieldLabel :text="question" :disabled="disabled" />
      <p
        v-if="value"
        v-linkify
        class="text-question__answer body-2 grey--text text--darken-4 ma-0 pa-0"
        :data-testid="`${tid}-value`"
        style="white-space: pre-line;"
      >
        {{ $sanitize(value, { allowedTags: ['a'] }) }}
      </p>
      <template v-else>
        <p v-if="isImpactValidated" class="text-body-1 ma-0 pa-0">
          -
        </p>
        <v-chip v-else small disabled class="label mt-2">{{
          $t('common.in_progress_status')
        }}</v-chip>
      </template>
    </div>
  </div>
</template>

<script>
import FieldLabel from '@/components/Core/FieldLabel'

export default {
  name: 'TextQuestion',

  components: {
    FieldLabel,
  },

  props: {
    resize: {
      type: String,
    },
    question: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
    },
    rows: {
      type: String,
      required: false,
      default: '1',
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    tid: {
      type: String,
      default: 'text-question',
    },
    tourId: {
      type: String,
      default: 'text-question',
    },
    maxLength: {
      type: Number,
      default: 140,
    },
    error: {
      type: Boolean,
      default: false,
    },
    isImpactValidated: Boolean,
  },

  methods: {
    // A bug in Vuetify is affecting placeholder's visibility when they're too long and the input starts with an empty value. In order to fix it, we have to first trigger a minor change and then, reset the input to its initial empty value so the "autogrow" functionallity actually does it job calculating the textarea's height.
    async ensurePlaceholderVisibility() {
      if (!this.value) {
        this.$emit('input', ' ')
        await this.$nextTick()
        this.$emit('input', '')
      }
    },
  },
}
</script>

<style lang="scss">
.text-question__answer {
  overflow-wrap: anywhere;
}
.text-question--error {
  .v-text-field__details,
  .v-label {
    color: var(--v-error-base);
  }
}
</style>
